import React, { createContext, useContext, useEffect, useState } from 'react';
import { Transaction, TransactionResponse } from '../../models/interfaces';
import topApi from '../../components/api/ToPApi';
import { AuthContext } from '../auth';
import moment from 'moment';
import { canFilterMerchants } from '../../utils/access';




type TransactionsContextProps = {
    transactions: Transaction[];
    totalPage: number;
    isLoading: boolean;
    // includeBranches: casa matriz, incluir las transacciones de sus sucursales
    loadTransactions: (page: number, startDate, endDate, merchant_id, transaction_id, method, type, includeBranches?: boolean) => Promise<void>;
    downloadTransactions: (startDate, endDate, merchant_id, transaction_id, method, type, includeBranches?: boolean) => Promise<void>;

    /*addTransaction: ( categoryId: string, transactionName: string ) => Promise<Transaction>;
    updateTransaction: ( categoryId: string, transactionName: string, transactionId: string ) => Promise<void>;
    deleteTransaction: ( id: string ) => Promise<void>;
    loadTransactionById: ( id: string ) => Promise<Transaction>;*/

}



export const TransactionsContext = createContext({} as TransactionsContextProps);



export const TransactionsProvider = ({ children }: any) => {

    const [transactions, setTransactions] = useState<Transaction[]>([]);
    const [totalPage, setTotalPage] = useState<number>(0);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { user } = useContext(AuthContext);
    const pageSize = 25;




    useEffect(() => {
        loadTransactions(0, moment().format("YYYY-MM-DD"), moment().add(1, 'day').format("YYYY-MM-DD"), -1, -1, 'tarjeta', '-1', true);
    }, [])


    const loadTransactions = async (pageActual, startDate, endDate, merchantid, transaction_id, method, type, includeBranches = false) => {

        setIsLoading(true);
        var merchantCode;

        // Plataforma y banco eligen el comercio (-1: todos los de su alcance); los usuarios de comercio usan el suyo
        // o, si son casa matriz, una de sus sucursales. El API aplica el mismo alcance aunque se envíe otro comercio.
        merchantCode = canFilterMerchants(user) || Number(merchantid) > 0 ? merchantid : (user.merchant?.id ?? -1);

        if (transaction_id == '')
            transaction_id = -1

        const req = {
            "merchantId": merchantCode,
            "startDate": startDate,
            "endDate": endDate,
            "pageIndex": pageActual,
            "pageSize": pageSize,
            "transactionId": transaction_id,
            "method": method,
            "type": type,
            "includeBranches": includeBranches
        }

        try {
            const resp = await topApi.post<TransactionResponse>('/transaction/bymerchant', req);
            setTransactions([...resp.data.transactions]);
            setTotalPage(resp.data.pages);
        } catch (error) {
            setTransactions([]);
            setTotalPage(0);
        } finally {
            setIsLoading(false);
        }

    }


    const downloadTransactions = async (startDate, endDate, merchantid, transaction_id, method, type, includeBranches = false) => {

        setIsLoading(true);

        let merchantCode;

        // Plataforma y banco eligen el comercio (-1: todos los de su alcance); los usuarios de comercio usan el suyo
        // o, si son casa matriz, una de sus sucursales. El API aplica el mismo alcance aunque se envíe otro comercio.
        merchantCode = canFilterMerchants(user) || Number(merchantid) > 0 ? merchantid : (user.merchant?.id ?? -1);

        if (transaction_id === '') transaction_id = -1;

        const req = {
            merchantId: merchantCode,
            startDate,
            endDate,
            transactionId: transaction_id,
            method,
            type,
            includeBranches
        };

        try {
            const resp = await topApi.post('/transaction/bymerchant/download', req, {
                responseType: 'blob' // 👈 CLAVE
            });

            // Crear URL del archivo
            const url = window.URL.createObjectURL(new Blob([resp.data]));

            // Crear link invisible
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'transactions.csv'); // nombre archivo

            document.body.appendChild(link);
            link.click();

            // Limpieza
            link.remove();
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error(error);
        }

        setIsLoading(false);
    };


    return (
        <TransactionsContext.Provider value={{
            transactions,
            totalPage,
            isLoading,
            loadTransactions,
            downloadTransactions
        }}>
            {children}
        </TransactionsContext.Provider>
    )
}